import { UtilFormTypes } from "models/formTypes";
import DateHelper from "./dateHelper";

const FilterHelper = {
  setNumberRange(filter: any, key: string, lowest?: number, highest?: number) {
    if (lowest !== undefined || highest !== undefined) {
      const range = {} as UtilFormTypes.NumberRange;
      if (lowest !== undefined) {
        range.lowest = lowest;
      }
      if (highest !== undefined) {
        range.highest = highest;
      }
      filter[key] = range;
    }
  },

  setDateRange(filter: any, key: string, start?: Date, end?: Date) {
    if (start !== undefined || end !== undefined) {
      const range = {} as UtilFormTypes.DateRange;
      if (start !== undefined) {
        range.start = DateHelper.fromAPIDate(start);
      }
      if (end !== undefined) {
        range.end = DateHelper.fromAPIDate(end);
      }
      filter[key] = range;
    }
  },
};

export default FilterHelper;
